var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.album.is_admin)?_c('div',{staticClass:"container"},[_c('webhooks',{attrs:{"scope":"album","album-id":_vm.album.album_id}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }